import script from "./TokenPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenPanel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__